import type { GetContractsResponse } from '@vy/api-definition';
import { LABEL_ENTITY_TYPES } from '@vy/types';
import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { EntityLabelsCell } from '../../../../components/new-design/molecules/labels';
import { queryKeys } from '../../../../services/query-key/query-keys';
import type { ItemOf } from '@vy/utils';

type ContractLabelsCellProps = {
  contract: ItemOf<GetContractsResponse['contracts']>;
};

export const ContractLabelsCell: FC<ContractLabelsCellProps> = ({ contract }) => {
  const queryClient = useQueryClient();

  const labelIds = useMemo(() => {
    return (contract.labels ?? []).map((label) => label.id);
  }, [contract.labels]);

  const handleUpdateSuccess = useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries(queryKeys.contracts()),
      queryClient.invalidateQueries(queryKeys.contractsOverview()),
      queryClient.invalidateQueries([queryKeys.labels()]),
    ]);
  }, [queryClient]);

  return (
    <EntityLabelsCell
      entityType={LABEL_ENTITY_TYPES.CONTRACT}
      entityId={contract.id}
      labelIds={labelIds}
      onUpdateSuccess={handleUpdateSuccess}
    />
  );
};
